import { CustomButton } from "../../CustomButton";
import { ChevronLeftIcon } from "../../../images";

const handleScrollToTop = () => {
  window.scrollTo({
    top: 0,
    behavior: "smooth",
  });
};

export const ToTopBtn = () => {
  return (
    <CustomButton
      customSize="fit"
      onClick={handleScrollToTop}
      style={{
        position: "fixed",
        bottom: "32px",
        right: "16px",
        zIndex: 10,
        color: "#4C545B",
        backgroundColor: "#E5E5E580",
        padding: "0 12px",
        gap: "4px",
      }}
      startIcon={<ChevronLeftIcon rotate="90" color="#4C545B" />}
    >
      To Top
    </CustomButton>
  );
};
